/* eslint-disable react-hooks/exhaustive-deps */

import { fetchData, isNull } from "App/utils/helpers";
import React, { useRef, useState, useEffect, useCallback } from "react";
import WrapperActiveMenu from "./WrapperActiveMenu";

import "./Wrapper.scss";
import { MA_NOTIFIKASI, TYPE_INSTANCE2 } from "App/constants";
import { MasterButton } from "App/Component/ui";
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  makeStyles,
  Menu,
  Paper,
  Tooltip,
  Typography,
  Zoom,
} from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";
import { getThema, getToken } from "App/utils/cookies";

import WrapperSearchMenu from "./WrapperSearchMenu";
import WrapperTab from "./WrapperTab";
import WrapperColorTheme from "./WrapperColorTheme";
import {
  changeActiveTab,
  changeInsuranceBpjsID,
  changePageProps,
  changeTabs,
  changeMinimize,
  changeTheme,
} from "./context/actions";
import { FullLoading } from "./Wrapper";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Badge from "@material-ui/core/Badge";
import { NotificationImportant } from "@material-ui/icons";
import { differentDayWithNow } from "utils/dates";
import { useDispatchWrapper } from "hooks";
import { fetchIdInsuranceBpjs } from "utils/registrations";
import useNetwork from "App/hooks/useNetwork";
import Cookies from "js-cookie";
import WrapperThemeProvider from "./WrapperThemeProvider";
import WrapperNetworkAction from "./WrapperNetworkAction";
import UserInformation from "./UserInformation/UserInformation";
import WrapperDeprecationBanner from "./WrapperDeprecationBanner";

const WrapperSidebar = React.lazy(() => import("./WrapperSidebar"));

function WrapperContainer({ clearNotification }) {
  const { state, dispatch, handleClickMenu, isLoading } = useDispatchWrapper();
  const getThemes = () => {
    const cookiesTema = Cookies.get("tema");
    const temaLogin = getThema();
    if (isNull(cookiesTema)) {
      if (isNull(temaLogin)) {
        return dispatch(
          changeTheme({
            sidebar_background: "#52525B",
            sidebar_color: "#D4D4D8",
            header: "#FFFFFF",
            header_color: "#797979",
            wrapper: "#FAFAFA",
            card_background: "#FAFAFA",
            tab: "#979797",
            tab_color: "#FFFFFF",
            tab_active: "#52525B",
            tab_active_color: "#FFFFFF",
            title: "Tema Farmasi",
          })
        );
      } else {
        return dispatch(changeTheme(JSON.parse(temaLogin)));
      }
    } else {
      return dispatch(changeTheme(JSON.parse(Cookies.get("tema"))));
    }
  };

  useEffect(() => {
    getThemes();
  }, []); // eslint-disable-next-line

  const themeList = state.theme_list;

  const { handleMoveTabNotif } = useDispatchWrapper();
  const useStyles = makeStyles((theme) => ({
    paper: {
      paddingBottom: 0,
    },
    list: {
      // marginBottom: theme.spacing(2),
      padding: "0",
    },
    subheader: {
      backgroundColor: theme.palette.background.paper,
    },
    appBar: {
      top: "auto",
      bottom: 0,
    },
    grow: {
      flexGrow: 1,
    },
    padding: {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    bold: {
      fontWeight: "bold",
    },
    boldText: {
      fontWeight: "500",
    },
    normal: {
      fontWeight: "400",
    },
    normalText: {
      fontWeight: "300",
    },
    custom_scrollbar: {
      "&::-webkit-scrollbar": {
        width: "4px",
        boxSizing: "border-box",
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: " 4px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: themeList.sidebar_color,
        borderRadius: "4px",
      },
    },
  }));
  const classes = useStyles(themeList);

  // const useGlobalStyles = makeStyles({
  //   "@global": {
  //     body: {
  //       "&::-webkit-scrollbar": {
  //         width: "4px",
  //         boxSizing: "border-box",
  //       },
  //       "&::-webkit-scrollbar-track": {
  //         borderRadius: " 4px",
  //       },
  //       "&::-webkit-scrollbar-thumb": {
  //         background: themeList.sidebar_color,
  //         borderRadius: "4px",
  //       },
  //     },
  //   },
  // });

  const sidebarRef = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  // const [openNotifOffline, setOpenNotifOffline] = React.useState(true);

  const handleNotifikasi = (event) => {
    setAnchorEl(event.currentTarget);
    clearNotification();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuNotifikasi = async () => {
    const nav = { code: MA_NOTIFIKASI, name: "Daftar Notifikasi" };
    handleClickMenu(nav);
  };

  const active = state.wrapper_active_tab;
  const menu = state.wrapper_active_menu;
  const notifList = state.notifikasi_list;
  const notifCount = state.notifikasi_count;
  const tabs = state.wrapper_tabs;

  const [deleteTab, setDeleteTab] = useState("");
  const [activeSearch, setActiveSearch] = useState(false);

  const [rows, setRows] = useState([]);
  const [offline, setOffline] = useState(false);
  const props = state.wrapper_page_props;

  const networkState = useNetwork();
  const { online, effectiveType } = networkState;
  useEffect(() => {
    (async () => {
      if (online === false) {
        if (offline === false) {
          // setOpenNotifOffline(true);
          setOffline(true);
        }
      } else {
        // setOpenNotifOffline(false);
        setOffline(false);
      }
    })();
  }, [online]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    (async () => {
      const token = getToken();
      if (token) {
        const res = await fetchData(TYPE_INSTANCE2, "/menumanagement/listmenu");
        const responseBpjs = await fetchIdInsuranceBpjs();
        if (res) {
          dispatch(changeInsuranceBpjsID(responseBpjs.data.id));
          setRows(res);
        } else {
          setRows([]);
        }
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickHamburger = () => {
    const minimize = sidebarRef.current.classList.contains("minimize");
    if (minimize) {
      sidebarRef.current.classList.remove("minimize");
      dispatch(changeMinimize(false));
    } else {
      sidebarRef.current.classList.add("minimize");
      dispatch(changeMinimize(true));
    }
  };

  useEffect(() => {
    if (deleteTab === active) {
      dispatch(changeActiveTab(""));
    }
  }, [deleteTab]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickRemoveTab = async (code) => {
    const newTabs = tabs.filter((e) => e.code !== code);

    if (tabs.length > 1) {
      const newActive =
        active === code ? newTabs[newTabs.length - 1].code : active;
      setDeleteTab(code);
      dispatch(changeActiveTab(newActive));
      dispatch(changeTabs(newTabs));

      if (menu === code) {
        dispatch(changePageProps(""));
      }
    } else {
      setDeleteTab(code);
      dispatch(changeActiveTab(""));
      dispatch(changeTabs([]));

      if (menu === code) {
        dispatch(changePageProps(""));
      }
    }
  };

  const handleClickTab = (code) => {
    dispatch(changeActiveTab(code));
  };

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F8") {
      setActiveSearch(true);
    }

    if (event.key === "Escape") {
      setActiveSearch(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <>
      {/* <Slide direction='up' in={openNotifOffline} mountOnEnter unmountOnExit>
        <Alert
          className='notifAlert'
          variant='filled'
          severity='error'
          action={
            <IconButton
              aria-label='close'
              color='inherit'
              size='small'
              onClick={() => {
                setOpenNotifOffline(!openNotifOffline);
              }}>
              <Close fontSize='inherit' />
            </IconButton>
          }>
          Tidak Dapat Terhubung Ke Internet, Mohon Periksa Koneksi Jaringan
          Anda.
        </Alert>
      </Slide> */}
      <div
        className={`wrapper ${activeSearch ? "active-search" : ""}`}
        ref={sidebarRef}
        style={{
          background: themeList.wrapper,
        }}>
        {isLoading && <FullLoading isLoading={isLoading} />}

        {rows.length > 0 && (
          <>
            <div
              className={`sidebar ${classes.custom_scrollbar}`}
              style={{
                background: themeList.sidebar_background,
              }}>
              <WrapperSidebar
                handleClickMenu={handleClickMenu}
                rows={rows}
                sidebarColor={themeList.sidebar_color}
              />
            </div>
            <div
              className='wrap'
              style={{
                background: themeList.wrapper,
              }}>
              <WrapperDeprecationBanner />
              <div
                className='header'
                style={{
                  background: themeList.header,
                }}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}>
                  <HamburgerIcon
                    onClick={handleClickHamburger}
                    themeList={themeList}
                  />

                  <p
                    className='top-nav-bars'
                    style={{
                      opacity: "0.5",
                      marginBottom: "4px",
                      fontSize: "10px",
                      color: isNull(themeList.header_color)
                        ? "#797979"
                        : themeList.header_color,
                    }}>
                    {" "}
                    F8 untuk mencari menu{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <div
                    style={{
                      marginRight: "-0.8rem",
                    }}>
                    <WrapperNetworkAction speed={effectiveType} stat={online} />
                  </div>
                  <div>
                    <Tooltip
                      title='Notifikasi'
                      aria-label='notifikasi'
                      TransitionComponent={Zoom}
                      arrow>
                      <IconButton
                        aria-label='Notifikasi'
                        color='inherit'
                        onClick={handleNotifikasi}>
                        <Badge badgeContent={notifCount} color='secondary'>
                          <NotificationsIcon
                            style={{
                              color: isNull(themeList.header_color)
                                ? "#797979"
                                : themeList.header_color,
                            }}
                            className='top-nav-bars'
                          />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                    <Menu
                      id='menu-appbar'
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          minHeight: "auto",
                          maxHeight: "20rem",
                          width: "24rem",
                          left: "0",
                          right: "15rem",
                          top: "3rem",
                        },
                      }}
                      MenuListProps={{
                        classes: { padding: classes.padding },
                      }}>
                      <Paper square className={classes.paper}>
                        <List className={classes.list}>
                          <ListSubheader className={classes.subheader}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}>
                              <Typography
                                variant='p'
                                id='countHarianS'
                                component='div'>
                                Notifikasi
                              </Typography>
                              <MasterButton
                                name={"LIHAT SEMUA NOTIFIKASI"}
                                type='button'
                                outline={true}
                                onClick={(e) => handleMenuNotifikasi()}
                                color={"green"}
                                size={"md"}
                              />
                            </div>
                          </ListSubheader>
                          {notifList.length > 0 ? (
                            notifList.map(
                              ({
                                id,
                                header_message,
                                message,
                                is_read,
                                createdAt,
                                kode_menu,
                                nama_menu,
                                table_id,
                              }) => (
                                <ListItem
                                  role={undefined}
                                  dense
                                  button
                                  onClick={(e) => {
                                    handleMoveTabNotif(
                                      id,
                                      kode_menu,
                                      nama_menu,
                                      table_id
                                    );
                                    handleClose();
                                  }}>
                                  <ListItemText
                                    primary={header_message}
                                    secondary={
                                      <label>
                                        {message}
                                        <br />
                                        {differentDayWithNow(createdAt)}
                                      </label>
                                    }
                                    classes={{
                                      primary: !is_read
                                        ? classes.bold
                                        : classes.normal,
                                      secondary: !is_read
                                        ? classes.boldText
                                        : classes.normalText,
                                    }}
                                  />
                                  {!is_read && (
                                    <ListItemSecondaryAction>
                                      <IconButton
                                        edge='end'
                                        aria-label='delete'>
                                        <NotificationImportant />
                                      </IconButton>
                                    </ListItemSecondaryAction>
                                  )}
                                </ListItem>
                              )
                            )
                          ) : (
                            <div
                              style={{
                                textAlign: "center",
                                width: "100%",
                                padding: "3rem 0rem",
                              }}>
                              <>Tidak Ada Notifikasi</>
                            </div>
                          )}
                        </List>
                      </Paper>
                    </Menu>
                  </div>

                  <UserInformation themeList={themeList} />
                  {/* <HamburgerIcon onClick={handleClickTemaModal} /> */}
                </div>
              </div>
              <WrapperThemeProvider>
                <div className='content'>
                  <WrapperTab
                    tabs={tabs}
                    handleClickRemoveTab={handleClickRemoveTab}
                    handleClickTab={handleClickTab}
                    active={active}
                    classes={classes}
                    themeList={themeList}
                  />
                  <WrapperActiveMenu
                    tabs={tabs}
                    handleChangeActive={handleClickTab}
                    handleClickMenu={handleClickMenu}
                    handleClickRemoveTab={handleClickRemoveTab}
                    active={active}
                    props={props}
                    menu={menu}
                  />
                </div>
              </WrapperThemeProvider>
            </div>{" "}
            <WrapperColorTheme themeList={themeList} />
          </>
        )}
      </div>

      {activeSearch && (
        <WrapperSearchMenu
          handleClickMenu={handleClickMenu}
          setActiveSearch={setActiveSearch}
        />
      )}
    </>
  );
}

const HamburgerIcon = ({ onClick, themeList }) => {
  return (
    <div className='hamburger' onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16px'
        className='h-6 w-6 top-nav-bars'
        fill='none'
        viewBox='0 0 24 24'
        stroke='currentColor'
        style={{
          color: isNull(themeList.header_color)
            ? "#797979"
            : themeList.header_color,
        }}>
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M4 6h16M4 12h16M4 18h16'
        />
      </svg>
    </div>
  );
};

export default WrapperContainer;
